const MAINTENANCE_ROUTE_PATH = '/maintenance';
const DEFAULT_ROUTE_PATH = '/';

const createMaintenanceRouteGuard = isMaintenanceModeEnabled => to => {
    const maintenanceModeEnabled = isMaintenanceModeEnabled();

    if (!maintenanceModeEnabled && to.path === MAINTENANCE_ROUTE_PATH) {
        return { path: DEFAULT_ROUTE_PATH };
    }

    if (!maintenanceModeEnabled) {
        return true;
    }

    if (to.path === MAINTENANCE_ROUTE_PATH) {
        return true;
    }

    return { path: MAINTENANCE_ROUTE_PATH };
};

export { MAINTENANCE_ROUTE_PATH, createMaintenanceRouteGuard };
